export enum SalesWorkflowSteps {
  'introduction'= 'introduction',
  'simulator'= 'simulator',
  'client-identification'= 'client-identification',
  'client-identification-express'= 'client-identification-express',
  'pre-client-verification'= 'pre-client-verification',
  'client-verification'= 'client-verification',
  'take-picture' = 'take-picture',
  'identity-document-photo' = 'identity-document-photo',
  'payment-information'= 'payment-information',
  'credit-setup'= 'credit-setup',
  'credit-bureau'= 'credit-bureau',
  'select-category' = 'select-category',
  'select-product' = 'select-product',
  'select-store' = 'select-store',
  'select-quota' = 'select-quota',
  'validate-geolocalization' = 'validate-geolocalization',
  'credit-summary' = 'credit-summary',
  'accept-credit-conditions' = 'accept-credit-conditions',
  'point-of-sales' = 'point-of-sales',
  'signing-contract'= 'signing-contract',
  'advanced-contract-signing' = 'advanced-contract-signing',
  'review-contract' = 'review-contract',
  'phone-app-instalation'= 'phone-app-instalation',
  'phone-register'= 'phone-register',
  'phone-enrollment'= 'phone-enrollment',
  'final-message-bank-transfer'= 'final-message-bank-transfer',
  'final-message-luki'= 'final-message-luki',
  'final-message-store'= 'final-message-store',
  'additional-customer-information' = 'additional-customer-information',
  'final-instructions-client' = 'final-instructions-client',
  'not-approved-request' = 'not-approved-request',
  'update-client-information' = 'update-client-information',
  'update-product-information' = 'update-product-information',
  'create-request' = 'create-request',
  'express-bureau' = 'express-bureau',
  'email-validation' = 'email-validation',
  'store-view-by-category' = 'store-view-by-category',
  'facematch-verification' = 'facematch-verification',
  'select-conditions' = 'select-conditions',
  'search-request' = 'search-request',
  'registered-application' = 'registered-application'
}

export enum SalesWorkflow {
  'kredicash-cliente'= 'kredicash-cliente',
  'kredicash-express'= 'kredicash-express',
  'general'= 'general',
  'autogestion-cliente'= 'autogestion-cliente',
  'autogestion-tienda'= 'autogestion-tienda',
  'gestion-tienda'= 'gestion-tienda',
  'general-tienda'= 'general-tienda',
  'domicilio-cliente'= 'domicilio-cliente',
  'domicilio-vendedor'= 'domicilio-vendedor',
  'app-krdya-cliente'= 'app-krdya-cliente',
  'app-krdya-general-tienda'= 'app-krdya-general-tienda',
  'app-krdya-gestion-tienda'= 'app-krdya-gestion-tienda',
  'app-krdya-kredicash'= 'app-krdya-kredicash',
  'claro-ecommerce' = 'claro-ecommerce',
  'general-experanza'= 'general-experanza',
  'pre-gestion-experanza'= 'pre-gestion-experanza',
  'post-gestion-experanza'= 'post-gestion-experanza'
}

export enum SalesWorkflowMacro {
  'macro-autogestion-cliente' = 'macro-autogestion-cliente',
  'macro-gestion-cliente' = 'macro-gestion-cliente',
  'macro-kredicash-cliente' = 'macro-kredicash-cliente',
  'macro-kredicash-express' = 'macro-kredicash-express',
  'macro-venta-domicilio' = 'macro-venta-domicilio',
  'macro-app-krdya' = 'macro-app-krdya',
  'macro-e-commerce' = 'macro-e-commerce',
  'macro-experanza' = 'macro-experanza'
}

export const MacroFlowMapping: Record<string, string[]> = {
  [SalesWorkflowMacro['macro-autogestion-cliente']]: [
    SalesWorkflow['general'],
    SalesWorkflow['autogestion-cliente'],
    SalesWorkflow['autogestion-tienda']
  ],
  [SalesWorkflowMacro['macro-gestion-cliente']]: [
    SalesWorkflow['general-tienda'],
    SalesWorkflow['gestion-tienda']
  ],
  [SalesWorkflowMacro['macro-kredicash-cliente']]: [
    SalesWorkflow['kredicash-cliente']
  ],
  [SalesWorkflowMacro['macro-kredicash-express']]: [
    SalesWorkflow['kredicash-express']
  ],
  [SalesWorkflowMacro['macro-venta-domicilio']]: [
    SalesWorkflow['domicilio-cliente'],
    SalesWorkflow['domicilio-vendedor']
  ],
  [SalesWorkflowMacro['macro-app-krdya']]: [
    SalesWorkflow['app-krdya-cliente'],
    SalesWorkflow['app-krdya-general-tienda'],
    SalesWorkflow['app-krdya-gestion-tienda'],
    SalesWorkflow['app-krdya-kredicash'],
  ],
  [SalesWorkflowMacro['macro-e-commerce']]: [
    SalesWorkflow['claro-ecommerce'],
  ],
  [SalesWorkflowMacro['macro-experanza']]: [
    SalesWorkflow['general-experanza'],
    SalesWorkflow['pre-gestion-experanza'],
    SalesWorkflow['post-gestion-experanza']
  ],
};

export const SalesWorkflowRequiresAuthentication: Record<SalesWorkflow, boolean> = {
  [SalesWorkflow['kredicash-cliente']]: false,
  [SalesWorkflow['kredicash-express']]: false,
  [SalesWorkflow['general']]: false,
  [SalesWorkflow['autogestion-cliente']]: false,
  [SalesWorkflow['autogestion-tienda']]: true,
  [SalesWorkflow['gestion-tienda']]: true,
  [SalesWorkflow['general-tienda']]: true,
  [SalesWorkflow['domicilio-cliente']]: false,
  [SalesWorkflow['domicilio-vendedor']]: true,
  [SalesWorkflow['app-krdya-cliente']]: false,
  [SalesWorkflow['app-krdya-general-tienda']]: true,
  [SalesWorkflow['app-krdya-gestion-tienda']]: true,
  [SalesWorkflow['app-krdya-kredicash']]: false,
  [SalesWorkflow['claro-ecommerce']]: false,
  [SalesWorkflow['general-experanza']]: true,
  [SalesWorkflow['pre-gestion-experanza']]: true,
  [SalesWorkflow['post-gestion-experanza']]: true
};
